var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:(("width: " + (_vm.gif.width) + "; height: " + (_vm.gif.height) + ";")),attrs:{"src":_vm.gif.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }